import { useUpdateTask } from '@api';
import { useNotification } from '@common';
import { modals } from '@mantine/modals';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

const TRANS_KEY_MODAL = 'CLOSE.CONFIRM_MODAL';
const TRANS_KEY_NOTIFICATION = 'NOTIFICATIONS.UPDATE_TASK_STATUS';

type UseUpdateTaskStatusReturnType = {
  handleClose: (taskId: string) => void;
  reopenTask: (taskId: string) => void;
};

export const useUpdateTaskStatus = (): UseUpdateTaskStatusReturnType => {
  const { t } = useTranslation('tasks');
  const { showError } = useNotification();
  const { mutate } = useUpdateTask();

  const onError = (error: AxiosError): void => {
    showError({
      title: `${TRANS_KEY_NOTIFICATION}.ERROR.TITLE`,
      message: `${TRANS_KEY_NOTIFICATION}.ERROR.MESSAGE`,
      error,
    });
  };

  const closeTask = (taskId: string): void => {
    mutate({ taskId, data: { status: 'CLOSED' } }, { onError });
  };

  const reopenTask = (taskId: string): void => {
    mutate({ taskId, data: { status: 'OPEN' } }, { onError });
  };

  const handleClose = (taskId: string): void => {
    modals.openConfirmModal({
      title: t(`${TRANS_KEY_MODAL}.TITLE`),
      labels: {
        confirm: t(`${TRANS_KEY_MODAL}.CONFIRM_BUTTON`),
        cancel: t('CANCEL_BUTTON', { ns: 'common' }),
      },
      confirmProps: {
        color: 'green',
      },
      onConfirm: () => closeTask(taskId),
    });
  };

  return { handleClose, reopenTask };
};
